import { IRadiolabelsHistoryFilters } from "@services/http/repositories/Radiolabels.repository";
import {
  ActionRadiolabelsHistoryBase,
  ActionRadiolabelsHistoryTypes,
  ActionRemoveRadiolabelsHistory,
} from "./actionTypes";

interface IState {
  filters: IRadiolabelsHistoryFilters;
}

const initialState: IState = {
  filters: {},
};

const reducer = (
  state = initialState,
  action: ActionRadiolabelsHistoryBase
): IState => {
  switch (action.type) {
    case ActionRadiolabelsHistoryTypes.ADD_FLITERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...(action.payload as IRadiolabelsHistoryFilters),
        },
      };

    case ActionRadiolabelsHistoryTypes.REMOVE_FLITER:
      const filters = { ...state.filters };
      delete filters[
        (action as unknown as ActionRemoveRadiolabelsHistory).payload
      ];

      return {
        ...state,
        filters,
      };

    default:
      return {
        ...state,
      };
  }
};

export default reducer;
